import { createContext, type FC, type ReactElement, useEffect, useState } from 'react';

type SidebarContext = {
  collapsed: boolean;
  setCollapsed: (val: boolean) => void;
  sidebarToggle: any;
  toggleSubMenu: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  changeUsersSubMenuToggle: () => void;
  toggleBrewersTSPsSubMenu: boolean;
  changeBrewersTSPsSubMenuToggle: () => void;
  toggleReportsSubMenu: boolean;
  changeReportsSubMenuToggle: () => void;
  isCollapsed: () => boolean;
};

export const SidebarContext = createContext<SidebarContext>({} as SidebarContext);

export const SidebarProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [toggleSubMenu, setToggleSubMenu] = useState(false);
  const [toggleBrewersTSPsSubMenu, setToggleBrewersTSPsSubMenu] = useState(false);
  const [toggleReportsSubMenu, setToggleReportsSubMenu] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    const isDesktopViewport = typeof window !== 'undefined' && window.matchMedia('(min-width:1200px)').matches;

    if (!isDesktopViewport) {
      setCollapsed(true);
    }

    setSidebarToggle(false);
  };

  const isCollapsed = (): boolean => {
    return collapsed;
  };

  const changeUsersSubMenuToggle = () => {
    setToggleSubMenu(!toggleSubMenu);
    setToggleBrewersTSPsSubMenu(toggleBrewersTSPsSubMenu);
  };

  const changeBrewersTSPsSubMenuToggle = () => {
    setToggleBrewersTSPsSubMenu(!toggleBrewersTSPsSubMenu);
  };

  const changeReportsSubMenuToggle = () => {
    setToggleReportsSubMenu(!toggleReportsSubMenu);
  };

  useEffect(() => {
    const savedCollapsedState = localStorage.getItem('sidebarCollapsed');

    if (savedCollapsedState !== null) {
      setCollapsed(savedCollapsedState === 'true');
      return;
    }

    const isDesktop = window.matchMedia('(min-width:1200px)').matches;
    setCollapsed(!isDesktop);
  }, []);

  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', String(collapsed));
  }, [collapsed]);

  return (
    <>
      <SidebarContext.Provider
        value={{
          collapsed,
          setCollapsed,
          sidebarToggle,
          toggleSubMenu,
          changeUsersSubMenuToggle,
          toggleBrewersTSPsSubMenu,
          changeBrewersTSPsSubMenuToggle,
          toggleReportsSubMenu,
          changeReportsSubMenuToggle,
          toggleSidebar,
          closeSidebar,
          isCollapsed
        }}
      >
        {children}
      </SidebarContext.Provider>
    </>
  );
};
